/**
 * testSettingsApi.js
 * ------------------
 * Live backend client API for Education > Test Settings.
 * Fully compliant with Rule 90 (Zero Mock Data).
 */
import api from '../../../../api/client'

export const DEFAULT_SETTINGS = {
  id: 1,
  populateMarks: 'A',
  smsToStudents: false,
  smsToFather: false,
  smsToMother: false,
  whatsappToStudents: false,
  whatsappToFather: false,
  whatsappToMother: false,
}

export async function getTestSettings() {
  const { data } = await api.get('/education/tests/settings')
  return {
    ...DEFAULT_SETTINGS,
    ...data,
    populateMarks: data.testPopulateMarks || data.populateMarks || 'A',
    smsToStudents: data.testSmsToStudents ?? data.smsToStudents ?? false,
    smsToFather: data.testSmsToFather ?? data.smsToFather ?? false,
    smsToMother: data.testSmsToMother ?? data.smsToMother ?? false,
    whatsappToStudents: data.testWhatsAppToStudents ?? data.whatsappToStudents ?? false,
    whatsappToFather: data.testWhatsAppToFather ?? data.whatsappToFather ?? false,
    whatsappToMother: data.testWhatsAppToMother ?? data.whatsappToMother ?? false,
  }
}

export async function updateTestSettings(payload) {
  const body = {
    testPopulateMarks: payload.populateMarks || payload.testPopulateMarks,
    testSmsToStudents: payload.smsToStudents ?? payload.testSmsToStudents,
    testSmsToFather: payload.smsToFather ?? payload.testSmsToFather,
    testSmsToMother: payload.smsToMother ?? payload.testSmsToMother,
    testWhatsAppToStudents: payload.whatsappToStudents ?? payload.testWhatsAppToStudents,
    testWhatsAppToFather: payload.whatsappToFather ?? payload.testWhatsAppToFather,
    testWhatsAppToMother: payload.whatsappToMother ?? payload.testWhatsAppToMother,
  }
  const { data } = await api.put('/education/tests/settings', body)
  return data
}
